/* eslint-disable no-underscore-dangle */
angular.module('leanlaw').factory('matterFilterService', ['$q', 'userService', function ($q, userService) {
  const _state = {
    loading: true
  };
  const _options = {
    loading: true
  };
  const _loaded = loadFilter();
  return {
    state: _state,
    options: _options,
    loaded: _loaded
  };
  function loadFilter() {
    return $q.all([userService.me(), userService.list()]).spread((me, accounts) => {
      delete _options.loading;
      delete _state.loading;
      _options.accounts = accounts.map(account => ({
        value: account.id,
        label: account.name,
        ...account
      }));
      if (me.role !== 'operator' && me.role !== 'accountant') {
        _state.scopeAccount = me;
      }
      _state.primary = me.role === 'lead' || me.role === 'principal';
      const lockByDefault = me.role === "lead" || me.role === "timekeeper" || me.role === "paralegal";
      _options.lockAccountSelection = lockByDefault && !me.permissions.matters.autoAssign;
      if (_options.lockAccountSelection) {
        _options.accounts = [me];
      }
      // _options.matters/_options.clients are intentionally not populated here --
      // they only feed llMatterFilter's filterSingleMatter dropdown mode, which no
      // current caller enables. A company-wide fetch here hits MatterService's
      // share-fanout query and can take well over a minute for firms with many
      // matters. If filterSingleMatter is used again, source these via the lean
      // /matters/options endpoint instead of an eager matterManager.list() call.
    });
  }
}]);